module.exports = __webpack_public_path__ + "img/avatar_cat.87c63c38.png";